import React from 'react';
import Utilities from '@util/Utilities';
import { ArrowsRightLeftIcon, KeyIcon, Squares2X2Icon, UserCircleIcon } from '@heroicons/react/24/outline';
import { useIntegrationSettingsAllowed } from '@app/site/secured/general-settings/fragment/integrations/IntegrationSettingsAccess';
import useSecurity from '@util/SecurityHook';
import Authority from '@app/model/authentication/Authority';
import { NavLink, Outlet } from 'react-router-dom';
import ACLAuthority from '@app/model/profile/ACLAuthority';


type Tab = {
	name: string,
	icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>,
	href: string,
	isActive?: boolean
}

const GeneralSettingsPage = React.memo(() => {

	const security = useSecurity();
	const integrationSettings = useIntegrationSettingsAllowed();

	const tabs: Tab[] = [
		...(integrationSettings.isAllowed ? [{ name: 'Integrations', icon: ArrowsRightLeftIcon, href: '/secured/settings/integrations', isActive: true }] : []),
		{
			name: 'General',
			icon: UserCircleIcon,
			href: '/secured/settings/general',
			isActive: security.hasAccess([Authority.ADMIN]),
		},
		{
			name: 'Property Access',
			icon: KeyIcon,
			href: '/secured/settings/property-access',
			isActive: security.hasAccess([Authority.ADMIN]),
		},
		{
			name: 'User Departments',
			icon: Squares2X2Icon,
			href: '/secured/settings/company-departments',
			isActive: security.hasAccess([Authority.ADMIN]),
		},
	];


	return <>
		<main>
			<div className="mx-auto max-w-7xl pt-2 lg:flex lg:gap-x-16 lg:px-8">
				<aside
					className="flex overflow-x-auto border-b border-gray-900/5 py-4 lg:block lg:w-64 lg:flex-none lg:border-0 lg:py-14">
					<nav className="flex-none px-4 sm:px-6 lg:px-0">
						<ul role="list" className="flex gap-x-3 gap-y-1 whitespace-nowrap lg:flex-col">
							{tabs.map((tab) => {
								return <li key={tab.name}>
									<NavLink to={tab.href}
													 className={({ isActive }) => Utilities.classNames(
														 isActive
															 ? 'bg-white text-blue-600'
															 : 'text-gray-700 hover:text-blue-600 hover:bg-white',
														 'group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm leading-6 font-semibold cursor-pointer',
													 )}
									>
										{({ isActive }) => <>
											<tab.icon
												className={Utilities.classNames(
													isActive ? 'text-blue-600' : 'text-gray-400 group-hover:text-blue-600',
													'h-6 w-6 shrink-0',
												)}
												aria-hidden="true"
											/>
											{tab.name}
										</>}


									</NavLink>
								</li>;

							})
							}
						</ul>
					</nav>
				</aside>

				<main className="px-4 py-16 sm:px-6 lg:flex-auto lg:px-0 lg:py-14">
					<Outlet />
				</main>
			</div>
		</main>
	</>;


});

export default GeneralSettingsPage;